import { Theme } from "@material-ui/core/styles";

export const getSliderProps = ({ breakpoints }: Theme) => ({
  arrows: true,
  draggable: false,
  infinite: false,
  responsive: [
    {
      breakpoint: breakpoints.values.lg,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: breakpoints.values.md,
      settings: {
        slidesToShow: 3
      }
    }
  ],
  slidesToScroll: 1,
  slidesToShow: 5
});
